import { render } from "./SimpleColumnChart.vue?vue&type=template&id=36d5ed30&scoped=true"
import script from "./SimpleColumnChart.vue?vue&type=script&lang=js"
export * from "./SimpleColumnChart.vue?vue&type=script&lang=js"

import "./SimpleColumnChart.vue?vue&type=style&index=0&id=36d5ed30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d5ed30"]])

export default __exports__